module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/close-f43737cbfe8ee829853a630f04a9706c.svg";